import { Body } from '@/presenters/Body';
import { ReflectorBody } from './ReflectorBody';
import { ReflectorIntegration } from './ReflectorIntegration';
import { BodyType } from '@/services/BodyType';

export class ReflectorBodyIntegration extends ReflectorIntegration {
	protected reconstitute(source: ReflectorBody): Body {
		return new Body(source.id, source.name, source.type as BodyType);
	}

	protected reconstituteAll(source: readonly ReflectorBody[]): readonly Body[] {
		return source.map((item) => this.reconstitute(item));
	}
}
